import { connect } from 'react-redux';
import ArticleListDialog from './articlelist-dialog';
import { getVisibleOrders } from '../../reselect/order.selector';
import { printArticleList, closeArticlelistDialog } from '../../reducers/order.reducers';

const mapStateToProps = state => ({
  open: !!state.orders.openArticlelistDialog,
  visibleArticles: getVisibleOrders(state),
  isEPosPrinterEnabled: state.app.localSettings.useEposPrinter,
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeArticlelistDialog()),
  printArticleList: (articles) => dispatch(printArticleList(articles)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArticleListDialog);
